import { render, staticRenderFns } from "./FinalisePoCostsDialog.vue?vue&type=template&id=4a5a6241&scoped=true"
import script from "./FinalisePoCostsDialog.vue?vue&type=script&lang=ts"
export * from "./FinalisePoCostsDialog.vue?vue&type=script&lang=ts"
import style0 from "./FinalisePoCostsDialog.vue?vue&type=style&index=0&id=4a5a6241&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a5a6241",
  null
  
)

export default component.exports